import { render } from "./NomenVerbPractice.vue?vue&type=template&id=25591ac2&scoped=true"
import script from "./NomenVerbPractice.vue?vue&type=script&lang=js"
export * from "./NomenVerbPractice.vue?vue&type=script&lang=js"

import "./NomenVerbPractice.vue?vue&type=style&index=0&id=25591ac2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25591ac2"]])

export default __exports__